export const TWO_FACTOR_VERIFICATION_MESSAGES = {
    OTP_EXPIRED: 'otp expired',
    OTP_INCORRECT: 'incorrect otp entered',
    OTP_LOCKED: 'your account has been temporarily locked',
    EMAIL_EXPIRE: 'expired email verification link',
    VERIFICATION_PAUSED: 'verification paused',
    USER_LOCKED: 'user is locked',
    VERIFICATION_INCOMPLETE: 'verification incomplete'
}; 

export const TWO_FACTOR_VERIFICATION_COOKIE_NAMES = {
    TWO_FACTOR_PASSED: 'rubii-2fa-passed',
    EMAIL_VERIFICATION_PAUSED: 'rubii-email-verification-paused',
    EMAIL_LAST_ATTEMPT: 'rubii-email-last-attempt',
    OTP_LAST_ATTEMPT: 'rubii-otp-last-attempt',
    OTP_GENERATION_PAUSED: 'rubii-otp-generation-paused',
    USER_LOCKED: 'rubii-user-locked',
    TWO_FACTOR_TRUSTED_DEVICE: 'rubii-2fa-trusted-device',
    TWO_FACTOR_TRUSTED_DEVICE_CHECKED: 'rubii-2fa-trusted-device-checked'
};  

export const twoFAFeatureId = 176320292101;

export enum TwoFactorEvents {
    UserLoggedInSuccessfully = 176333705602,
    UserLoggedInFailed = 176333709901, // token??
    TwoFAPassedByEmail = 176333714302,
    TwoFAPassedByMobile = 176333718503,
    TwoFAFailedByEmail = 176333721701,
    TwoFAFailedByMobile = 176333724001,
    UserLocked = 176333729001,
    UserUnlockByAdmin = 176333730902,
    UserAddedMobile = 176333733501,
}